<template>
  <section class="content">
    <div class="row center-block">
      <div class="box text-center">
        <!-- /.box-header -->
        <div class="box-body form">
          <div>
            <div class="pull-right" v-if="$route.name === 'upProductIcon'" style="position: absolute; top: 0; right: 0;" >
              <button class="btn btn-danger inline-block"data-toggle="modal" data-target="#delIconModal"><i class="fa fa-trash"></i></button>
            </div>
            <br><br>
          </div>
          <div>
            <div class="input-group">
              <span class="input-group-addon">
                <span class="text-red">＊ </span>名稱
              </span>
              <input class="form-control" placeholder="" type="text" v-model="iconInfo.name" maxlength="45">
            </div>
            <br />
          </div>
          <div>
            <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊ </span>排序
            </span>
              <input class="form-control" placeholder="" v-model="iconInfo.sort" maxlength="99" type="tel" @keyup="veritySort" ref="sort">
            </div>
            <br>
          </div>
          <div>
            <div class="input-group">
            <span class="input-group-addon">
              <span class="text-red">＊ </span>啟用
            </span>
              <div class="form-group">
                <select class="form-control" v-model="iconInfo.is_visible">
                  <option value="1">啟用</option>
                  <option value="0">停用</option>
                </select>
              </div>
            </div>
            <br />
          </div>
          <div>
            <div class="input-group">
            <span class="input-group-addon">
              描述
            </span>
              <input class="form-control" placeholder="" type="text" v-model="iconInfo.description" maxlength="100">
            </div>
            <br />
          </div>
          <div>
            <div class="input-group">
          <span class="input-group-addon">
            <span class="text-red">＊ </span>圖片
          </span>
              <div class="input-group-addon w-100-p text-center p-all-0 bg-white" style="border-right: none;">
            <span class="inline-block h-auto m-t-5">
              <div v-if="!iconInfo.image_file" class="text-black" v-text="'沒有圖片'" />
              <img :src="iconInfo.image_file" class="h-auto img-responsive" v-if="iconInfo.image_file" data-toggle="modal">
            </span>
              </div>
              <div class="form-control h-100">
                <div>
                  <label class="btn-upload btn btn-default m-t-25" style="margin-top: 8px;" for="brand-img-load">
                    選擇圖片
                  </label>
                  <input class="form-control" type="file" style="display: none;" @change="onFileChange" id="brand-img-load">
                </div>
              </div>
            </div>
          </div>
          <div class="text-right text-15 text-red">(圖片最大為200x200)<br /></div>
        </div>

        <div class="box-footer text-center">
          <button class="btn btn-default" @click="$router.go(-1)">
            取消
          </button>
          <button class="btn btn-success" v-if="$route.name === 'crProductIcon'" @click="checkBeforeSend('cr')">
            新增
          </button>
          <button class="btn btn-success" v-else @click="checkBeforeSend('up')">
            修改
          </button>
        </div>
        <br />
      </div>
    </div>
    <m-modal :option="delIconOption" @trigger="trigger"></m-modal>
  </section>
</template>
<script>
import $ from 'jquery'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
// import moment from 'moment'
import VueTimepicker from 'vue2-timepicker'
import { mapGetters } from 'vuex'

// import 'src/static/js/plugins/notify/notify.min.js'
export default {
  data () {
    return {
      img: {
        width: 0,
        height: 0
      },
      iconList: [],
      iconInfo: {
        name: '',
        image_file: '',
        sort: 1,
        is_visible: 1,
        description: ''
      },
      storeInfo: {},
      // time
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      delIconOption: {
        id: 'delIconModal',
        title: '刪除菜單圖示',
        body: '確定刪除菜單圖示？',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delIcon'
          }
        ]
      }
    }
  },
  methods: {
    trigger (event) {
      if (event === 'delIcon') {
        this.delIcon()
      }
    },
    delIcon () {
      var self = this
      var url = 'store/' + this.$route.params.store_id + '/productIcon/' + this.$route.params.icon_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: '圖片刪除成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace({ path: self.returnPage })
        }
      })
    },
    init () {
      // this.getStoreInfo()
      if (this.$route.name === 'upProductIcon') this.getProductIconList()
    },
    veritySort () {
      var e = $(this.$refs.sort)
      this.iconInfo.sort = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    getProductIconList () {
      var self = this
      // self.bindList = []
      var url = 'store/' + this.$route.params.store_id + '/productIconList'
      this.getDataH('get', url, null, function (response) {
        self.iconList = response.data.list
        self.iconInfo = self.iconList.find(function (iconObj) { return iconObj.icon_id === parseInt(self.$route.params.icon_id, 10) })
        console.log(self.iconInfo.url)
        self.$set(self.iconInfo, 'image_file', self.iconInfo.url)
      })
    },
    onFileChange (e) {
      this.imgLogoSelect = ''
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      let imgSize = Math.round(files[0].size / 1000)
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else if (imgSize > 512) {
        this.$notify({
          title: '提醒',
          text: '圖片檔案為' + imgSize + 'KB，請上傳小於512KB之圖片',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.createImage(files[0])
      }
    },
    createImage (file) {
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        var img = new Image()
        img.src = e.target.result
        self.iconInfo.image_file = img.src
        img.onload = () => {
          self.img.width = img.width
          self.img.height = img.height
          self.checkImgSize()
        }
      }
      reader.readAsDataURL(file)
    },
    checkImgSize (type) {
      var self = this
      if ((this.img.width > 200 || this.img.height > 200) && this.img.width !== 0 && this.img.height !== 0) {
        this.$notify({
          title: '提醒',
          text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳200x200以下之圖片！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      }
    },
    checkBeforeSend (type) {
      let all = this.getInput
      let msg = ''
      if (!all.name) {
        msg = '請輸入圖示名稱'
      } else if (!all.sort) {
        msg = '請輸入排序'
      } else if (!$('#brand-img-load')[0].files[0] && type === 'cr') {
        msg = '請上傳一張圖片'
      }
      this.getToast(msg, type)
    },
    getToast (msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        if (type === 'cr') this.createdIcon()
        else if (type === 'up') this.updatedIcon()
      }
    },
    createdIcon () {
      var self = this
      var data = new FormData()
      var info = this.getInput
      var name = info.name
      var description = info.description
      var picUrl = info.url
      var sort = parseInt(info.sort, 10)
      if (!picUrl) picUrl = ' '
      data.append('name', name)
      data.append('sort', sort)
      data.append('is_visible', this.iconInfo.is_visible)
      if (description) data.append('description', description)
      // console.log(startTime, endTime)
      // icon 圖片
      data.append('image_file', $('#brand-img-load')[0].files[0])
      var url = 'store/' + this.$route.params.store_id + '/newProductIcon'
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            self.$router.replace({ path: self.returnPage })
          }
        })
      }
    },
    updatedIcon () {
      var self = this
      var data = new FormData()
      var info = this.getInput
      var name = info.name
      var description = info.description
      var picUrl = info.url
      var sort = parseInt(info.sort, 10)
      if (!picUrl) picUrl = ' '
      data.append('name', name)
      data.append('sort', sort)
      data.append('is_visible', this.iconInfo.is_visible)
      if (description) data.append('description', description)
      // console.log(startTime, endTime)
      // icon 圖片
      if ($('#brand-img-load')[0].files[0]) {
        data.append('image_file', $('#brand-img-load')[0].files[0])
      }
      var url = 'store/' + this.$route.params.store_id + '/productIcon/' + this.$route.params.icon_id
      if (data) {
        this.getDataH('post', url, data, function (response) {
          if (response.data.status === 200) {
            self.$notify({
              title: response.data.message,
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
            self.$router.replace({ path: self.returnPage })
          }
        })
      }
    }
  },
  created () {
    this.init()
  },
  components: {
    'date-time-picker': datetimePicker,
    VueTimepicker
  },
  computed: {
    ...mapGetters(['getRoleType']),
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    },
    getInput () {
      var aInfo = this.iconInfo
      for (let key in aInfo) {
        if (!aInfo[key] && typeof aInfo[key] === 'object') aInfo[key] = ' '
      }
      return {
        name: this.checkInput(aInfo.name.toString()),
        sort: this.checkInput(aInfo.sort.toString()),
        description: this.checkInput(aInfo.description.toString())
      }
    },
    returnPage () {
      return `/storeTable/productImage/${this.$route.params.brand_id}/${this.$route.params.store_id}?tab=99`
    }
  }
}
</script>
<style lang="sass" scoped>
@media screen and (min-width: 992px)
  .box-body.form-left
    left: 5%
    width: 40%
  .box-body.form-right
    left: 4%
    width: 40%
@media screen and (max-width: 991px)
  .box-body.form-left, .box-body.form-right
    padding-left: 0px
    padding-right: 0px
</style>
<style lang="sass">
@media screen and (max-width: 767px)
  .cr-ad.input-group.cr-schedule .cov-vue-date .cov-datepicker
    width: calc(100vw - 165px)
</style>



// WEBPACK FOOTER //
// CrIconSetting.vue?1e2eaf84